import React, { FC, useMemo } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { MultiSelect, MultiSelectPropertiesInterface } from '@affstore-ds/uikit'

import { InputLoader } from '../../shared/components/InputLoader'
import { commonTranslationKeys } from '../../shared/translations/common.translationKeys'
import { selectTranslationKeys } from '../../shared/translations/select.translationKeys'
import { promoBannerSizesMultiSelectTranslationKeys } from './translations/promoBannerSizesMultiSelect.translationKeys'

import { usePromoBannerSizes } from '../../entities/hooks/usePromoBannerSizes'

export const PromoBannerSizesMultiSelect: FC<Omit<MultiSelectPropertiesInterface, 'data'> & { imageSizes?: string[] }> = ({
  label,
  disabled,
  imageSizes,
  ...rest
}) => {
  const { i18n } = useI18n()
  const { bannerSizes, bannerSizesIsLoading } = usePromoBannerSizes(imageSizes)

  const BANNER_SIZES_LIST_PREPARED = useMemo(
    () =>
      (imageSizes || bannerSizes).map((bannerSize) => ({
        'data-testid': `promo-banner-sizes-item-${bannerSize}`,
        label: bannerSize,
        value: bannerSize,
      })),
    [bannerSizes, imageSizes],
  )

  return (
    <MultiSelect
      data-testid="promo-banner-sizes-multi-select"
      label={label || i18n.t(promoBannerSizesMultiSelectTranslationKeys.promoBannerSizesLabel)}
      bottomSheetTitle={label || i18n.t(promoBannerSizesMultiSelectTranslationKeys.promoBannerSizesLabel)}
      clearLabel={i18n.t(selectTranslationKeys.selectClear)}
      data={BANNER_SIZES_LIST_PREPARED}
      disabled={disabled || bannerSizesIsLoading}
      emptySearchLabel={i18n.t(commonTranslationKeys.commonNoData)}
      maxDropdownHeight={400}
      placeholder={i18n.t(promoBannerSizesMultiSelectTranslationKeys.promoAllSizesPlaceholder)}
      position="bottom"
      rightSection={bannerSizesIsLoading && <InputLoader />}
      selectAllLabel={i18n.t(selectTranslationKeys.selectSelectAll)}
      variant="responsive"
      {...rest}
    />
  )
}
